import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const AgentUserProfileInfoComponent = ({ onInnerFormChange, selectedAgents }: any) => (
          <>
  <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
              label="FirstName"
              name="FirstName"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'UserProfile.FirstName',
                  selectedAgents?.UserProfile
                )
              }}
              type="text"
              value={selectedAgents?.UserProfile?.FirstName}
          />
       <InputContainer
              label="Last Name"
              name="LastName"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'UserProfile.LastName',
                  selectedAgents?.UserProfile
                )
              }}
              type="text"
              value={selectedAgents?.UserProfile?.LastName}
          />
      <InputContainer
              label="PersonTitle"
              name="PersonTitle"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'UserProfile.PersonTitle',
                  selectedAgents?.UserProfile
                )
              }}
              type="text"
              value={selectedAgents?.UserProfile?.Email}
          />
    <InputContainer
              label="ProfilePicture Url"
              name="ProfilePictureUrl"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'UserProfile.ProfilePictureUrl',
                  selectedAgents?.UserProfile
                )
              }}
              type="text"
              value={selectedAgents?.UserProfile?.ProfilePictureUrl}
          />
    </div>
 }
 expandedPanel="basicInfo"
 headerTitle="Basic Info"
/>
</>
)
export default AgentUserProfileInfoComponent;
